var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none","display":"block"},attrs:{"src":_vm.$route.query.path,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }